export const checkIsPostbackUrlValid = urlString => {
    try {
        const url = new URL(urlString);
        return url.protocol === "http:" || url.protocol === "https:";
    } catch (e) {
        return false;
    }
}
